import * as angular from 'angular';
import { isUndefined } from 'lodash';

export const IdentitySamlForm: angular.IComponentOptions = {
  controller: class {
    public onToggleEnabled: ($providerToken: any) => void;
    public providerToken: string;
    public defaultCollapsed: boolean;
    public isCollapsed = true;
    public isEditing = false;
    public displayName: string;
    public editableDisplayName: string;
    public certificate: string;
    public editableCertificate: string;
    public providerSsoUrl: string;
    public editableProviderSsoUrl: string;
    public onDestroyProvider: ($providerToken: any) => void;
    public onUpdateProvider: any;
    public providerIsDefault: boolean;
    public defaultIsEditing: boolean;

    static $inject = [];
    constructor() {}

    $onInit() {
      if (!isUndefined(this.defaultCollapsed)) {
        this.isCollapsed = this.defaultCollapsed;
      }
      if (!isUndefined(this.defaultIsEditing)) {
        this.isEditing = this.defaultIsEditing;
      }
    }

    $onChanges(changed: angular.IOnChangesObject) {
      const { displayName, providerSsoUrl, certificate } = changed;
      if (displayName.currentValue) {
        this.editableDisplayName = displayName.currentValue;
      }
      if (providerSsoUrl.currentValue) {
        this.editableProviderSsoUrl = providerSsoUrl.currentValue;
      }
      if (certificate.currentValue) {
        this.editableCertificate = certificate.currentValue;
      }
    }

    resetEditableFields() {
      this.editableDisplayName = this.displayName;
      this.editableProviderSsoUrl = this.providerSsoUrl;
      this.editableCertificate = this.certificate;
    }

    handleToggleCollapsed() {
      this.isCollapsed = !this.isCollapsed;
    }

    handleEditButtonClick() {
      this.isEditing = true;
    }

    handleCancelEditButtonClick() {
      this.isEditing = false;
      this.resetEditableFields();
    }

    handleDestroyProviderClick() {
      // tell your identity-saml.component parent to destroy
      const $providerToken = this.providerToken;
      this.onDestroyProvider({ $providerToken });
    }

    handleUpdateProviderClick() {
      // tell your identity-saml.component parent to update
      const $providerToken = this.providerToken;
      const $editableDisplayName = this.editableDisplayName;
      const $editableProviderSsoUrl = this.editableProviderSsoUrl;
      const $editableCertificate = this.editableCertificate;
      this.onUpdateProvider({
        $providerToken,
        $editableDisplayName,
        $editableProviderSsoUrl,
        $editableCertificate,
      });
    }

    handleToggleEnabledClick(providerId: string) {
      const $providerToken = providerId;
      this.onToggleEnabled({ $providerToken });
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    displayName: '<',
    providerSsoUrl: '<',
    certificate: '<',
    assertionUrl: '<',
    entityId: '<',
    providerToken: '<',
    defaultCollapsed: '<?',
    onDestroyProvider: '&',
    onResetProvider: '&',
    onUpdateProvider: '&',
    providerIsDefault: '<',
    enabled: '<',
    onToggleEnabled: '&',
    defaultIsEditing: '<?',
  },
  template: `
  <div ng-class="{'collapsed': ctrl.isCollapsed, 'saml-identity-item-container': true }">
    <div class="saml-item-header">
      <div class="saml-item-header-txt">

        <div class="saml-identity-title">
          <div class="icon-container">
            <span class="icon-lock-black">
            </span>
          </div>
          <h5>
            {{ ctrl.displayName }}
          </h5>
        </div>

        <div class="show-configuration-labels" ng-click="ctrl.handleToggleCollapsed()">
          <span>{{ ctrl.isCollapsed ? 'VIEW' : 'HIDE' }} CONFIGURATION</span>
          <span ng-class="{'collapsed': ctrl.isCollapsed, 'icon-caret-down': true }"></span>
        </div>

      </div>

      <div class="saml-item-header-toggle">
      <identity-provider-toggle
        on-click="ctrl.handleToggleEnabledClick($providerId)"
        provider-id="ctrl.providerToken"
        provider-is-default="ctrl.providerIsDefault"
        enabled="ctrl.enabled"
      />
      </div>
    </div>

    <div class="forms-section">
      <div class="saml-provider-info">
        <div class="form-group">
          <span class="info-label">Display Name (4 - 255) characters</span>
          <input
            class="form-control"
            ng-model="ctrl.editableDisplayName"
            ng-disabled="!ctrl.isEditing"
          >
          </input>
        </div>

        <div class="form-group">
          <span class="info-label">Identity Provider SSO URL</span>
          <input
            class="form-control"
            ng-model="ctrl.editableProviderSsoUrl"
            ng-disabled="!ctrl.isEditing"
          >
          </input>
        </div>

        <div class="form-group pem-input-form">
          <span class="info-label">Identity provider certifcate (PEM)</span>
          <textarea
            class="form-control"
            ng-model="ctrl.editableCertificate"
            ng-disabled="!ctrl.isEditing"
            rows="10"
          ></textarea>
        </div>
      </div>

      <hr />

      <p class="saml-info-note">The below information may be required by your identity provider:</p>

      <div class="saml-mode-info">
        <div class="form-group">
          <span class="info-label">Assertion Consumer Service Url</span>
          <copy-to-clipboard-field
            input-content="ctrl.assertionUrl"
            input-is-enabled="false"
            input-is-password="false"
          />
        </div>
        <div class="form-group">
          <span class="info-label">Entity ID</span>
          <copy-to-clipboard-field
            input-content="ctrl.entityId"
            input-is-enabled="false"
            input-is-password="false"
          />
        </div>
        <div class="form-group">
          <span class="info-label">Provider Token</span>
          <copy-to-clipboard-field
            input-content="ctrl.providerToken"
            input-is-enabled="false"
            input-is-password="false"
          />
        </div>
      </div>

      <div class="button-actions">
        <div ng-if="!ctrl.isEditing" class="edit-not-active">
          <button ng-click="ctrl.handleEditButtonClick()" class="btn btn-lg btn-filled-primary pull-right">
            Edit
          </button>
        </div>
        <div ng-if="ctrl.isEditing" class="edit-active">
          <button ng-click="ctrl.handleDestroyProviderClick()"
            class="btn btn-lg btn-optional-action pull-right delete-saml-provider-btn">
            Delete
          </button>
          <button ng-click="ctrl.handleCancelEditButtonClick()" class="btn btn-lg btn-optional-action pull-right">
            Cancel
          </button>
          <button ng-click="ctrl.handleUpdateProviderClick()" class="btn btn-lg btn-filled-primary pull-right">
            Save
          </button>
        </div>
      </div>
      <!-- end button actions -->
    </div>
    <!-- end forms-section -->
  </div>
  `,
};
